<script>
  export default {
    name: "MainCard",
    props: {
      padding: {
        type: Number,
        default: 16,
      },
      radius: {
        type: Number,
        default: 10,
      },
      className: {
        type: String,
        default: "",
      },
    },
  };
</script>

<template>
  <div :class="['mainCard', className]" :style="{ padding: padding + 'px', borderRadius: radius + 'px' }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .mainCard {
    @include Flex(column, flex-start, flex-start);
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px #0000001a;
  }
</style>
